import React from "react";
import css from "./Pictures.module.css";
import Url from "../../../Services/Url";
import { FileText } from "lucide-react";

const Picture = ({ children }) => {
  if (!children) return null;

  let { value, uploadType, uploadId } = children;

  // If uploadId but no base64 (image stored on server)
  if (uploadId && !value && uploadType?.startsWith("image/")) {
    value = Url.img.thumb(uploadId);
  }

  // PDF
  if (uploadType?.includes("pdf")) {
    return (
      <div className={css.FilePreview}>
        <FileText size={40} />
        <div className={css.FileLabel}>PDF Document</div>
      </div>
    );
  }

  // DOC/DOCX
  if (uploadType?.includes("word") || uploadType?.includes("officedocument")) {
    return (
      <div className={css.FilePreview}>
        <FileText size={40} />
        <div className={css.FileLabel}>Word Document</div>
        <small>{value}</small>
      </div>
    );
  }

  // Image
  if (uploadType?.startsWith("image/")) {
    return (
      <div className={css.img}>
        <img src={value} width={200} alt="Uploaded" />
      </div>
    );
  }

  return (
    <div className={css.FilePreview}>
      <FileText size={40} />
      <div className={css.FileLabel}>Unknown File</div>
      <small>{value}</small>
    </div>
  );
};

export default Picture;
